import { useRef, useState } from "react";

import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Panel } from "primereact/panel";

import { useReactToPrint } from "react-to-print";

export const ColaboradorDefeitoTipo = ({ data }) => {
    const [printing, setPrinting] = useState(false);
    const ref = useRef();

    const handlePrint = useReactToPrint({
        content: () => ref.current,
        onBeforeGetContent: () => {
            return new Promise((resolve) => {
                setPrinting(true);
                setTimeout(() => {
                    resolve();
                }, 500);
            });
        },
        onAfterPrint: () => {
            setPrinting(false);
        }
    });

    if(data === null)
        return null;

    return (
        <div>
            <Panel
                collapsed
                header={'TABELA DE DEFEITOS POR COLABORADOR E TIPO DE DEFEITO'}
                toggleable
            >
                <div className="p-d-flex p-flex-row p-m-1">
                    <Button 
                        className="p-button-primary"
                        icon="pi pi-print"
                        onClick={handlePrint}
                    />
                </div>
                <div ref={ref}>
                    <h3>{data.title}</h3>
                    <DataTable
                        filterDisplay={printing ? "" :"row"}
                        responsiveLayout="scroll"
                        style={{ fontSize: 12 }}
                        size="small"
                        value={data.colaborador_tipodefeito}
                    >
                        <Column header="Colaborador" field="colaborador" filter showFilterMenu={false} sortable />
                        <Column header="Turma" field="turma" filter showFilterMenu={false} sortable />
                        <Column header="Defeito" field="defeito" filter showFilterMenu={false} sortable />
                        <Column header="Total (m)" field="total" showFilterMenu={false} sortable />
                    </DataTable>
                </div>
            </Panel>
        </div>
    )
}